import { Table as MantineTable } from '@mantine/core';
import { forwardRef } from 'react';
import { clx } from './clx';
import classes from './table.module.css';
export const GoodTableThead = forwardRef(({ children, ...props }, ref) => {
    return (<MantineTable.Thead ref={ref} {...props} bg={props.bg ?? 'var(--gray-bg)'} className={clx(classes.tableThead, props.className)}>
      {children}
    </MantineTable.Thead>);
});
